/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-19 15:37:01
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-07 15:06:38
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorProductSearch/SearchBarPlaceHolder/index.tsx
 */
import React from 'react';

import css from './css.less';

import { Collapse, Input } from '@/src/components/Antd';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import GeneralCollapseContent from 'src/constrains/SalesChannelPreviewPageComponents/GeneralCollapseContent';
import GeneralCollapseHeader from 'src/constrains/SalesChannelPreviewPageComponents/GeneralCollapseHeader';
import GeneralCollapseWrapper from 'src/constrains/SalesChannelPreviewPageComponents/GeneralCollapseWrapper';

import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';

import { useDispatch, useSelector } from 'react-redux';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  onCollapseOpen,
  onSearchBarPlaceholderChange,
} from '../slice';
const SearchBarPlaceHolder = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { isPrimary, withoutCollapse, collapseOpenDefault } = props;
  const _id = EnumCollapseId.searchBar;
  const _d = useDispatch();
  const { placeholder } = useSelector(
    (state: any) => state.salesChannelContent.productSearch.searchBar,
  );
  const handleOnCollapseOpen = (status: boolean) => {
    const _g = status ? [_id] : [];
    _d(onCollapseOpen({ idArr: _g }));
  };
  const _open = withoutCollapse || useSelector(getCollapseOpenStatus(_id));

  const handleOnPlaceholderChange = (e) => {
    _d(onSearchBarPlaceholderChange(e));
  };
  const options = [
    {
      onClick: () => {
        handleOnPlaceholderChange(getI18n('general.filterGroup.search'));
      },
      key: 'Reset',
      body: (
        <div className={css.reset}>{getI18n('general.hOCTitle.reset')}</div>
      ),
    },
  ];
  const renderTitle = () => {
    return (
      <GeneralCollapseHeader
        {...(isPrimary ? { hasDots: true, dotsFunction: options } : {})}
        // hasDots
        // dotsFunction={options}
        content={getI18n('salesChannelContent.index.searchBarPlaceholder')}
      />
    );
  };
  return (
    <GeneralCollapseWrapper>
      <Collapse
        id={_id}
        open={_open}
        title={renderTitle()}
        withoutCollapse={withoutCollapse}
        content={
          <GeneralCollapseContent>
            <Section>
              <ItemWrapper
                title={`${getI18n(
                  'salesChannelContent.index.searchBarPlaceholder',
                )} (${getI18n('general.optional')})`}
                rightPart={`${placeholder.length}/20`}>
                <Input
                  maxLength={20}
                  size='large'
                  value={placeholder}
                  onChange={handleOnPlaceholderChange}
                />
              </ItemWrapper>
            </Section>
          </GeneralCollapseContent>
        }
        clickToExpand
        //open={true}
        expandOffset={collapseOpenDefault ? 0 : 12}
        onClickTrigger={handleOnCollapseOpen}
      />
    </GeneralCollapseWrapper>
  );
};
export default SearchBarPlaceHolder;
